import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  template: '#t-customer-contact',
});
